import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    padding: '0px',
  },
  logoContainer: {
    padding: '13px',
    boxShadow: '0px 4px 4px 0px #00000040',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'start',
      alignItems: 'start',
    },
  },
  logo: {
    maxWidth: '200px',
    maxHeight: '80px',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 'clamp(300px, 75.26vw, 1440px)',
    margin: '0 auto',
    gap: '30px',
    padding: 'clamp(15px, 1.93vw, 39px) 0px',
    [theme.breakpoints.down('md')]: {
      width: 'clamp(303px, 84.10vw, 328px)',
      margin: '0 auto',
      gap: '30px',
      padding: '35px 0px',
    },
  },
  headerContainer: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '30px',
    },
  },
  headerContent: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  mainTitle: {
    fontWeight: 700,
    fontSize: 20,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('md')]: {
      fontSize: 35,
    },
  },
  subtitle: {
    fontSize: 14,
    fontFamily: 'Varela Round',
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
      marginBottom: 0,
    },
  },
  stepsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
      alignItems: 'end',
      gap: '10px',
      justifyContent: 'right',
    },
  },
  stepCircle: {
    width: 38.25,
    height: 38.25,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 15,
    transition: 'all 0.3s ease',
  },
  stepActive: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
  },
  stepCompleted: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  stepInactive: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[600],
  },
  formContent: {
    backgroundColor: theme.palette.primary.white,
    boxShadow: '0px 0px 4px 0px #00000040',
    borderRadius: theme.shape.borderRadius,
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    gap: '10px',
    backgroundColor: theme.palette.primary.white,
    [theme.breakpoints.up('md')]: {
      gap: '32px',
    },
  },
  stepHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    paddingBottom: '20px',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: '10px',
    },
  },
  stepHeaderContainer: {
    paddingBottom: '0px',
    [theme.breakpoints.up('md')]: {
      paddingBottom: '0px',
    },
  },
  stepNumber: {
    width: 38.25,
    height: 38.25,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 15,
  },
  stepTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: '#5BC2D5',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: theme.spacing(3),
    },
  },
  fieldsContainerStep2: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.shape.borderRadius,
    },
  },
  textareaLabel: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.palette.text.primary,
    fontFamily: 'Varela Round',
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
    },
  },
  textareaField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.shape.borderRadius,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
      alignSelf: 'flex-end',
      gap: '35px',
      minWidth: '635px',
    },
  },
  button: {
    borderRadius: theme.shape.borderRadius,
    textTransform: 'none',
    width: '100%',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
    [theme.breakpoints.up('md')]: {
      width: '300px',
    },
  },
  buttonText: {
    fontSize: 20,
    fontWeight: 500,
  },
  sectionDescription: {
    color: theme.palette.text.primary,
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    color: theme.palette.text.primary,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: '30px',
    },
  },
  checkboxLabel: {
    '& .MuiFormControlLabel-label': {
      fontFamily: 'Varela Round',
      fontSize: '16px',
      [theme.breakpoints.up('md')]: {
        fontSize: '20px',
      },
    },
  },
  datePicker: {
    color: theme.palette.primary.main,
    '& .MuiInputBase-input': {
      color: theme.palette.primary.main,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  errorAlert: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '370px',
    },
  },
}));

export default useStyles;
